import React from 'react';
import { useTranslations } from 'next-intl';
import styled from 'styled-components';

import Copy from '@components/atoms/copy/copy';
import Headline from '@components/atoms/headline/headline';

import { getSpace, mq } from '@stylesheets/tools';
import ItemWrapper from './ItemWrapper';

const StyledErrorItem = styled.div`
  text-align: left;
  padding: ${getSpace('xs')} ${getSpace('s')};

  ${mq('m')} {
    text-align: center;
  }

  ${mq('m')} {
    padding: ${getSpace('xl')} ${getSpace('m')};
  }

  h3 {
    margin-bottom: ${getSpace('xxxxs')};
  }

  p {
    margin: 0;
  }
`;

const ErrorItem = () => {
  const t = useTranslations();
  return (
    <ItemWrapper borderColor="darkGray">
      <StyledErrorItem>
        <Headline tag="h3" subline>
          {t('archive.errorHeadline')}
        </Headline>

        <Copy fullWidth small>
          {t('archive.errorCopy')}
        </Copy>
      </StyledErrorItem>
    </ItemWrapper>
  );
};

export default ErrorItem;
